var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Header, Input, Loader } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var CancelShipmentModal = /** @class */ (function (_super) {
    __extends(CancelShipmentModal, _super);
    function CancelShipmentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.props.postRequest("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/shipments/id/" + encodeURIComponent(_this.props.shipmentId) + "/cancel-shipment", {
                trackingNumber: _this.props.trackingNumber
            });
        };
        return _this;
    }
    CancelShipmentModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.props.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement("div", { className: 'field-group' },
                React.createElement("p", null,
                    "Are you sure you want to cancel this shipment for order ",
                    this.props.orderId),
                React.createElement(Header, null, "Tracking Number"),
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/trackingNumber', labelContent: '' },
                    React.createElement(Input, { value: this.props.trackingNumber })),
                React.createElement(Header, null, "Cancel Shipment"),
                React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, onClick: this.submit, negative: true, icon: 'x', label: 'Cancel Shipment', labelPosition: 'left' })));
    };
    return CancelShipmentModal;
}(React.PureComponent));
export default CancelShipmentModal;
//# sourceMappingURL=CancelShipmentModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/CancelShipmentModal.js
// module id = 1180
// module chunks = 0